// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__20vrp","imageUploader":"EGiftCard_imageUploader__1g7D0"};